/* unplugin-vue-components disabled */import { render } from "./titleAssembly.vue?vue&type=template&id=15cab6c5"
import script from "./titleAssembly.vue?vue&type=script&lang=js"
export * from "./titleAssembly.vue?vue&type=script&lang=js"

import "./titleAssembly.vue?vue&type=style&index=0&id=15cab6c5&scope=true&lang=css"

import exportComponent from "E:\\work\\weitu_land_page_h5\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__